<script>
import { mapActions } from 'vuex'
import CartView from '@app/Cart/View'
import analyticCartAdd from '@analytic/add.js'

import {
  addTripToCart,
} from '@api/cart.service'

import {
  AnswerMessage,
} from '@utils/submit'

export default {
  name: 'AddToCart',
  props: {
    id: {
      type: [String, Number],
    },
    type: {
      type: String,
    },
    amount: {
      type: [String, Number],
    },
    price: {},
    name: {},
    trip: {},
  },
  data() {
    return {
      load: false,
    }
  },
  methods: {
    ...mapActions('cart', [
      'changeCart',
    ]),
    prepare() {
      const entity = {
        element: {
          id: this.id,
          type: this.type,
        },
        quantity: this.amount,
      }
      const entities = []
      entities.push(entity)
      return entities
    },
    processCardChange() {
      const entities = this.prepare()
      this.addToCart(entities)
    },
    async addToCart(entities) {
      console.log("🚀 ~ entities:", entities)
      this.load = true
      try {
        // if (this.trip) {
        //   await addTripToCart.execute({}, { id: this.trip })
        // }
        let element = null
        let product = { price: this.price, id: this.id, amount: this.amount }
        console.log("🚀 ~ product:", product)
        await this.changeCart({ data: { entities }, retrieve: false }).then(async ({ data }) => {
          element = data.groups.find(e => e.base.element.id === this.id)
          console.log("🚀 ~ element:", element)
          if (element) {
            const { brand: { props: { title: brand } }, categories, title: name } = element.base.element.props.product.props
            const { price } = data
            analyticCartAdd(
              name, this.id, price, this.amount, brand, categories.map(l => l.props.title)
            )
          }
        })
        this.openCart(element.id, product)
        this.load = false
      } catch (e) {
        console.log(e);
        this.load = false
        const { errors } = await e.json()
        const [error] = errors
        const [first] = error.state.non_field_errors
        const meta = {
          message: {
            header: this._('Максимальна кількость товарів перевищена. Даний товар вже є у кошику'),
            title: first.message,
          },
        }
        AnswerMessage(meta, this)
      }
    },
    openCart(elementId, product) {
      this.$modal.show(
        CartView,
        {
          element: elementId,
          product,
          retrieve: false,
        }, {
          height: 'auto',
          classes: ['cart-modal'],
          adaptive: true,
          scrollable: true,
        }
      )
    },
  },
  render(h) {
    window.totisAddToCart = this.addToCart
    return this.$scopedSlots.default({
      add: () => {
        this.processCardChange()
      },
      load: this.load,
    })
  },
}
</script>
